import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { getApiUrl, tokenInterceptor } from '@app/api/index';

export const supportApi = createApi({
  reducerPath: 'supportApi',
  baseQuery: fetchBaseQuery({
    baseUrl: getApiUrl('/support'),
    prepareHeaders: tokenInterceptor,
  }),
  endpoints: (builder) => ({
    createSupport: builder.mutation({
      query: (supportForm) => ({
        url: `/`,
        method: 'POST',
        body: {
          ...supportForm,
        },
      }),
    }),
  }),
});

export const { useCreateSupportMutation } = supportApi;
